// Generated by Melange

import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(title) {
  return function (className) {
    return function (children) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    title !== undefined ? JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                            className: "mb-2 animate-fadeIn",
                            children: title
                          }) : null,
                    JsxRuntime.jsx("div", {
                          children: children
                        })
                  ],
                  className: Cn.fromList({
                        hd: "p-6 sm:p-10 bg-white rounded-md shadow",
                        tl: {
                          hd: Cn.take(className),
                          tl: /* [] */0
                        }
                      })
                });
    };
  };
}

function Box(Props) {
  return Curry._1(make(Props.title)(Props.className), Props.children);
}

const make$1 = Box;

export {
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
